import moment from 'moment';
import React from 'react';
import img from '../../styles/edit.png';
import styles from '../NavBar/Navbar.module.scss';
import { NavLink } from 'react-router-dom';

// @ts-ignore
export default () => {
    return [
        {
            name: 'Institute',
            id: 'companyParentName',
            // @ts-ignore
            selector: row => {
                return row.companyParentName.charAt(0).toUpperCase() + row.companyParentName.slice(1);
            },
            sortable: true
        },
        {
            name: 'Company',
            id: 'companyName',
            // @ts-ignore
            selector: row => {
                if(!row.companyName) return row.companyName
                return row.companyName.charAt(0).toUpperCase() + row.companyName.slice(1);
            },
            sortable: true
        },
        {
            name: 'Website',
            id: 'website',
            // @ts-ignore
            selector: row => row.website,
            // @ts-ignore
            format: row => {
                if(!row.website) return row.website
                const link = 'https://logo.clearbit.com/'+ row.website.charAt(0).toUpperCase() + row.website.slice(1)
                return row.website !== null
                    // ? row.logo.charAt(0).toUpperCase() + row.logo.slice(1)
                    ?    <a href={row.website} target="_blank" style={{display: 'inline-block', position: 'relative', zIndex: '0'}}>
                                <div style={{display: 'inline-block' }}>
                                    <object type="text/html" data={link}  style={{
                                        position: 'relative',
                                        zIndex: '-1',
                                        width: '150px',
                                        height: '150px',
                                        transformOrigin: '5px 5px',
                                        marginBottom: 'calc((0.3 - 1) * 100%)',
                                        transform: 'scale(0.3) translate(20%, 0%)'
                                    }}>
                                        website link
                                     </object>
                                </div>
                         </a>
                    : row.website
            },
            sortable: true
        },
        {
            name: 'Type',
            id: 'organisationsType',
            // @ts-ignore
            selector: row => row.organisationType,
            // @ts-ignore
            format: row => {
                return row.organisationType
            },
            sortable: true
        },
        {
            name: 'Founder',
            id: 'founder',
            // @ts-ignore
            selector: row => row.founder,
            // @ts-ignore
            format: row => {
                return row.founder ? row.founder : '-'
            },
            sortable: true
        },
        {
            name: 'Founding date',
            id: 'foundingDate',
            // @ts-ignore
            selector: row => row.foundingDate,
            // @ts-ignore
            format: row => {
                if(!row.foundingDate) {
                    return '-'
                }
                const date = moment(`${row.foundingDate}-01`)
                date.locale('nl')
                return date.format('MMM YYYY')
            },
            sortable: true,
            style: {
                minWidth: "40px"
            }
        },
        {
            name: 'Sector',
            id: 'sector',
            // @ts-ignore
            selector: row => row.sector,
            // @ts-ignore
            format: row => {
                if(!row.sector) return row.sector
                return row.sector !== null
                    ? row.sector.charAt(0).toUpperCase() + row.sector.slice(1)
                    : '-'
            },
            sortable: true
        },
        {
            name: 'Creation Date',
            id: 'createdAt',
            // @ts-ignore
            selector: row => row.createdAt,
            // @ts-ignore
            format: row => {
                const dateTimeSplit = row.createdAt.split(' ')
                const parts = dateTimeSplit[0].split('-')
                return `${parts[2]}-${parts[1]}-${parts[0]} ${dateTimeSplit[1]}`;
            },
            sortable: true
        },
        {
            name: 'Edit',
            id: 'editColumn',
            // @ts-ignore
            cell: (row, index, column, id) => {
                const url = `/admin/organisations/${row.id}/edit`
                return <NavLink className={styles.button} to={url}>
                    <img src={img}></img>
                </NavLink>
            }
        },
    ];
}
